import { render } from "./EditAttributeValue.vue?vue&type=template&id=5270b6a2&ts=true"
import script from "./EditAttributeValue.vue?vue&type=script&lang=ts"
export * from "./EditAttributeValue.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__